"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["className", "style", "items", "onNavClick", "extra", "hidenBottomline", "responsive", "mode", "fullResponsive"];
var AnchorPanel = function AnchorPanel(props) {
  var className = props.className,
    style = props.style,
    items = props.items,
    onNavClick = props.onNavClick,
    extra = props.extra,
    hidenBottomline = props.hidenBottomline,
    responsive = props.responsive,
    mode = props.mode,
    fullResponsive = props.fullResponsive,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('anchor-panel-nav');
  var classes = (0, _classnames2.default)(prefixCls, className, (0, _defineProperty2.default)({
    'is-hidenline': hidenBottomline,
    responsive: responsive,
    'is-full-responsive': fullResponsive
  }, "mode-".concat(mode), mode && mode != 'default'));
  var clickHandle = function clickHandle(item) {
    if (typeof onNavClick === 'function') {
      onNavClick(item);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: style
  }, extraProps), /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames2.default)("".concat(prefixCls, "__items"))
  }, !!items && items.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames2.default)("".concat(prefixCls, "__item"), {
        'is-selected': item.selected
      }),
      key: index,
      onClick: function onClick() {
        return clickHandle(item);
      }
    }, item.name);
  })), extra && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__extra")
  }, extra));
};
var _default = AnchorPanel;
exports.default = _default;